@if (variant === 'a') {
  <div class="modal-header">
    <button
      id="btnClose"
      type="button"
      class="btn-close close"
      aria-label="Close"
      (click)="onClick('crossClick')"
    >
      <span aria-hidden="true" class="visually-hidden">&times;</span>
    </button>
    <h4
      class="section-title modal-title float-start"
    >
      {{ titleText }}
    </h4>
  </div>
  <div
    class="modal-body"
    [innerHTML]="messageText | safeHtml: SanitizerValueType.HTML"
  ></div>
  <div class="modal-footer">
    <button
      *ngIf="secondaryBtnText"
      class="btn btn-secondary-underlined"
      (click)="onClick('secondaryClick')"
    >
      {{ secondaryBtnText }}
    </button>
    <button
      *ngIf="primaryBtnText"
      class="btn btn-primary-yellow"
      (click)="onClick('primaryClick')"
    >
      {{ primaryBtnText }}
    </button>
  </div>
}

@if (variant === 'b') {
  <div class="modalb-wrapper">
    <div class="modalb-close" (click)="onClick('crossClick')">
      <app-svg-icon icon="close-icon" size="small" fill="black"></app-svg-icon>
    </div>
    @if (imageUrl) {
      <img [src]="imageUrl" class="modalb-image" />
    }

    @if (titleText) {
      <div class="modalb-title">{{titleText}}</div>
    }

    @if (messageText) {
      <div class="modalb-message" [innerHTML]="messageText | safeHtml: SanitizerValueType.HTML"></div>
    }
    <div class="modalb-footer">
      <button *ngIf="secondaryBtnText" class="btn2-secondary" (click)="onClick('secondaryClick')">
        {{ secondaryBtnText }}
      </button>
      <button *ngIf="primaryBtnText" class="btn2-primary" (click)="onClick('primaryClick')">
        {{ primaryBtnText }}
      </button>
    </div>
  </div>
}
